import GenericInformationTable, {
    TableRow
} from "components/ui/table/GenericInformationTable";
import { IProductCriteriaInfo } from "types";
import { CapacityLeadState } from "../types/enums";

interface CapacityLeadProductCriteriaInformationTableProps {
    capacityLeadProductCriteriaInfo: {
        capcityLeadState: CapacityLeadState;
        productCriteriaList: IProductCriteriaInfo[];
    };
}

/**
 * CapacityLeadProductCriteriaInformationTable displays product criteria
 * information associated with a waiting list lead. It shows values in plain text
 * if the lead is acquired or open (not closed), or masks them otherwise.
 */
function CapacityLeadProductCriteriaInformationTable({
    capacityLeadProductCriteriaInfo
}: CapacityLeadProductCriteriaInformationTableProps) {
    if (!capacityLeadProductCriteriaInfo) return null;

    const { productCriteriaList } = capacityLeadProductCriteriaInfo;

    const rows: TableRow[] = productCriteriaList.map((criteria) => ({
        fieldName: criteria.criteriaName,
        value: criteria.value
    }));

    // Determine the table title using your existing helper
    const tableTitle = "Produktkriterien";

    return <GenericInformationTable title={tableTitle} rows={rows} />;
}

export default CapacityLeadProductCriteriaInformationTable;
